import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { promoterAPI, referralStore } from '../lib/api';

/**
 * Promoter links and QR codes point here: /r/:code. Records the click, keeps
 * the code for the event (used at checkout for attribution) and forwards to
 * the event page.
 */
export default function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    promoterAPI.trackClick(code)
      .then(r => {
        referralStore.set(r.data.event_id, r.data.referral_code);
        navigate(`/events/${r.data.event_id}`, { replace: true });
      })
      .catch(() => setFailed(true));
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] pt-24 text-center px-4">
      {failed ? (
        <>
          <p className="text-white font-bold mb-2">This promotion link is no longer active.</p>
          <Link to="/explore" className="text-red-400 hover:text-red-300">Explore events instead</Link>
        </>
      ) : (
        <p className="text-gray-400">Taking you to the event…</p>
      )}
    </div>
  );
}
